import { memo } from "react";
import { translateCategory } from "common/app/command-palette/translation";
import { Category, Command } from "common/app/command-palette/types";
import { isGroupedOption } from "common/vendor-wrappers/react-select/functions";
import { LabelledOptionOrGroup } from "common/vendor-wrappers/react-select/types";

type CommandItemProps = {
  icon?: string;
  label: string;
  category?: Category;
};

const CommandItem = memo(({ icon, label, category }: CommandItemProps) => (
  <div className="x-command">
    <div className="x-command-label">
      {icon && (
        <div className="x-command-icon">
          <i className={`fa ${icon}`} data-testid={icon} />
        </div>
      )}
      <div className="x-command-name">{label}</div>
    </div>
    {category && (
      <span className="badge badge-secondary x-badge pull-right">
        {translateCategory(category)}
      </span>
    )}
  </div>
));

CommandItem.displayName = "CommandItem";

export const formatCommand = (option: LabelledOptionOrGroup<Command>) => {
  if (isGroupedOption(option)) return option.label;

  const { icon, label, category } = option.value;
  return <CommandItem icon={icon} label={label} category={category} />;
};
